import { CACHE_TIMES } from '@/config/cache';
import type { DateRange, SelectedNetwork, ShowFilter } from '@/types';
import { useCampaignTypesQuery } from '@/services/revenueApi';

/**
 * This hook is used to fetch the campaign type earnings data.
 * @param selectedNetwork - The selected network.
 * @param modalDateRange - The date range.
 * @param enabled - Whether the query is enabled.
 * @returns The daily earnings by campaign type.
 */

const useCampaignTypesData = (
  selectedNetwork: SelectedNetwork | undefined,
  modalDateRange: DateRange,
  enabled: boolean,
  modalSelectedShow?: ShowFilter
) => {
  return useCampaignTypesQuery(
    selectedNetwork?.id ?? '',
    modalDateRange.from,
    modalDateRange.to,
    {
      enabled,
      refetchOnMount: false,
      staleTime: CACHE_TIMES.SHORT,
    },
    {
      showIds: modalSelectedShow !== 'all' && modalSelectedShow ? [modalSelectedShow] : undefined,
    }
  );
};

export default useCampaignTypesData;
